<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbMission } from '@/models/alodb/AloDbMission'
import AdminAdminMissionListLine from '@/components/admin/adminMission/AdminAdminMissionListLine.vue'
import AdminAdminMissionFilter from '@/components/admin/adminMission/AdminAdminMissionFilter.vue'
import { FilterAdminMission } from '../../../models/filter/FilterAdminMission'


@Component({
  name: 'AdminAdminMissionList',
    components: {AdminAdminMissionListLine,AdminAdminMissionFilter}
})

export default class AdminAdminMissionList extends AdminList<AloDbMission> {  
 
  get itemTypeName() {
    return "AdminMission"
  }

  get items()  {             
    return this.$store.myGetters.adminMissions.filter(m => 
      (this.filter.search.length == 0 ||  m.searchString!.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1) &&
      (this.filter.ownerIds.length == 0 || this.filter.ownerIds.indexOf(m.gliderEnsId!) > -1) &&
      (this.filter.gliderIds.length == 0 || this.filter.gliderIds.indexOf(m.GLI_ID!) > -1) &&
      //(!this.filter.simulated || m.isTestMission) &&
      (!this.filter.onGoing || m.MIS_ACTIF_ON)
    )    
  }

  get componentLineName(){
    return "AdminAdminMissionListLine"
  } 

  get componentFilterName() {
    return 'AdminAdminMissionFilter'
  }

  get filter(){
    return this.$store.myGetters.adminAdminMissionFilter
  }

  get nbFiltre() {    
    return this.filter.ownerIds.length + (this.filter.search.length > 0?1:0) + this.filter.gliderIds.length + (this.filter.onGoing?1:0) + (this.filter.simulated?1:0)
  }

  resetFilter() {
    this.$store.myActions.ADMINMISSION_UPDATE_FILTER_ADM(new FilterAdminMission())
  }

}
</script>